import React, { useMemo } from "react";
import { FiBarChart2 } from "react-icons/fi";
import { COLORS, STAGE_COLOR_PALETTE } from "../myDashboardConstants";
import { SectionCard } from "../components/SectionCards";
import { PipelineDropdown } from "../components/PipelineDropdown";

export function PipelineDistribution({
  pipelines,
  selectedPipeline,
  onPipelineChange,
  data,
}) {
  const stages = useMemo(() => {
    const rows = Array.isArray(data) ? data : [];
    return rows.map((r, i) => ({
      name: r.stage_name || "-",
      value: Number(r.total_count) || 0,
      fill: STAGE_COLOR_PALETTE[i % STAGE_COLOR_PALETTE.length],
    }));
  }, [data]);

  const hasData = stages.length > 0;
  const max = hasData ? Math.max(...stages.map((d) => d.value), 1) : 1;

  // faint placeholder cells when a pipeline has no stages yet
  const displayStages = hasData
    ? stages
    : [0, 1, 2, 3].map(() => ({ name: "—", value: 0, fill: "#E2E7F0" }));

  return (
    <SectionCard
      title="Pipeline Distribution"
      subtitle="Deals across each stage"
      icon={<FiBarChart2 size={16} />}
      accent={COLORS.purple}
      action={
        <PipelineDropdown
          pipelines={pipelines}
          value={selectedPipeline}
          onChange={onPipelineChange}
        />
      }
    >
      <div className="sd-pipeline-scroll">
        <div className="sd-pipeline-grid">
          {displayStages.map((d, i) => (
            <div
              className="sd-pipeline-cell"
              key={d.name + i}
              style={!hasData ? { opacity: 0.6 } : undefined}
            >
              <div className="sd-pipeline-cell-top">
                <span
                  className="sd-pipeline-icon"
                  style={{
                    background: `${d.fill}1A`,
                    color: hasData ? d.fill : COLORS.muted,
                  }}
                >
                  <FiBarChart2 size={15} />
                </span>
                <h3
                  className="fw-normal text-dark mb-0"
                  title={d.value.toLocaleString()}
                  style={{
                    letterSpacing: "-0.02em",
                    color: hasData ? undefined : COLORS.muted,
                  }}
                >
                  {d.value.toLocaleString()}
                </h3>
              </div>
              <div
                className="sd-pipeline-label"
                title={d.name}
                style={!hasData ? { color: COLORS.muted } : undefined}
              >
                {d.name}
              </div>
              <div className="sd-activity-track">
                <div
                  className="sd-activity-fill"
                  style={{
                    width: hasData
                      ? `${Math.max(6, (d.value / max) * 100)}%`
                      : "20%",
                    background: hasData ? d.fill : "#E2E7F0",
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </SectionCard>
  );
}
